import React from "react"

const FormSubmissionFormContext = React.createContext(null)

export default FormSubmissionFormContext
